import { useTheme, lighten, darken } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useEditedStyles = makeStyles(() => {
  const theme = useTheme();

  return {
    input: {
      "& .MuiFilledInput-root": {
        backgroundColor: lighten(theme.palette.warning.light, 0.6),
      },
    },
    background: {
      backgroundColor: lighten(theme.palette.warning.light, 0.6),
    },
    chip: {
      backgroundColor: lighten(theme.palette.warning.light, 0.6),
      color: darken(theme.palette.warning.dark, 0.4),
    },
    withHover: {
      backgroundColor: lighten(theme.palette.warning.light, 0.6),
      "&:hover": {
        backgroundColor: lighten(theme.palette.warning.light, 0.5),
      },
    },
    menuItem: {
      "& .MuiListItem-root": {
        backgroundColor: lighten(theme.palette.warning.light, 0.6),
        boxShadow: `3px 0px 0px ${theme.palette.warning.dark} inset`,
        "&:hover": {
          backgroundColor: lighten(theme.palette.warning.light, 0.5),
        },
      },
      "&.NavLink-active .MuiListItem-root": {
        boxShadow: `3px 0px 0px ${theme.palette.warning.main} inset`,
      },
    },
  };
});

export const useEditedColor = () => {
  const theme = useTheme();
  return {
    background: lighten(theme.palette.warning.light, 0.6),
    hover: lighten(theme.palette.warning.light, 0.5),
    text: darken(theme.palette.warning.dark, 0.4),
  };
};

export default useEditedStyles;
